module.exports = __webpack_public_path__ + "static/media/upp_flo_tie_lad.d5d7ccef.png";